export const crmManagement = 'allow to manage crm settings';
export const docplannerUrlIntegration = 'allow to manage integration with url';
